import { cx } from '@linaria/core';
import { textTitle } from 'styles/typography';
import { genGradient } from 'components/EntityCard/utils';
import { defaultThumbnail } from './Thumbnail.styles';

interface ThumbnailProps extends React.HTMLAttributes<HTMLDivElement> {
  fallback?: string;
  src?: string;
  className?: string;
}

const DEFAULT_GRADIENT_TEXT = 'clarifai';

export const Thumbnail: React.FC<ThumbnailProps> = ({ src, fallback = '', className, ...rest }) => {
  return (
    <div
      className={cx(textTitle, defaultThumbnail, className)}
      style={{ backgroundImage: src ? `url('${src}')` : genGradient(fallback || DEFAULT_GRADIENT_TEXT, 'diagonal') }}
      {...rest}
    >
      {!src ? fallback.charAt(0) : null}
    </div>
  );
};
